import React, { useState, useEffect, useRef } from "react";
import { Row, Col, Button, Form, Dropdown, ButtonGroup } from "react-bootstrap";
import LeaveLayout from "../../components/LeaveLayout.js";
import { MdAddCircle} from "react-icons/md";
import { LuCalendarMinus, LuCalendarPlus } from "react-icons/lu";
import { IoMdAdd } from "react-icons/io";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css"; // Import the CSS for the date picker
import "./leaves.css";
import axios from "axios";

export default function Leaves() {
  const [showDialog, setShowDialog] = useState(false);
  const [showTabs, setShowTabs] = useState(false);
  const [selectedTab, setSelectedTab] = useState("");
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [showReasonContainer, setShowReasonContainer] = useState(false);
  const [setEntries] = useState(10); // Corrected state variable
  const [searchTerm, setSearchTerm] = useState("");
  const [leaves, setLeaves] = useState([]); // State to store leaves data
  const datePickerRef = useRef(null);

  // Function to calculate the number of days between start and end dates
  const calculateDays = (startDate, endDate) => {
    const oneDay = 24 * 60 * 60 * 1000;
    const diffDays = Math.round(Math.abs((startDate - endDate) / oneDay));
    return diffDays + 1; // Add 1 to include both the start and end date
  };

  // Fetch leaves when component mounts
  const fetchLeaves = async () => {
    const userId = localStorage.getItem("userId");
    if (!userId) {
      console.error("User ID not found in session storage");
      return;
    }

    try {
      const response = await axios.get(
        `http://localhost:5544/api/leaves/user/${userId}`
      );
      console.log("Leaves fetched successfully:", response.data.leaves);
      setLeaves(response.data.leaves); // Update state with fetched leaves
    } catch (error) {
      console.error("Error fetching leaves:", error.response.data.message);
    }
  };

  useEffect(() => {
    fetchLeaves(); // Fetch leaves on component mount
  }, []);

  const handleButtonClick = () => {
    setShowDialog(!showDialog);
  };

  const handleTabToggle = () => {
    setShowTabs(!showTabs);
    setShowReasonContainer(!showTabs); // Toggle reason container visibility based on tabs
  };

  const handleTabSelect = (tab) => {
    setSelectedTab(tab);
    setShowTabs(false); // Optionally close the dropdown after selection
  };

  const handleAddLeave = async () => {
    const userId = localStorage.getItem("userId");
    const name = localStorage.getItem("name");
    const username = localStorage.getItem("username");


    // Debugging - check if values are retrieved correctly
    console.log("Retrieved userId:", userId);
    console.log("Retrieved username:", name);
    console.log("Retrieved username:", username);

    if (!userId || !name) {
      alert("User not logged in. Please log in again.");
      return;
    }

    const leaveData = {
      userId,
      name,
      username,
      leaveType: selectedTab, // Selected leave type from the dropdown
      startDate,
      endDate,
      reason: document.querySelector(".reason-textarea").value, // Grab reason from textarea
      days: calculateDays(startDate, endDate), // Calculate the number of days
    };

    try {
      const response = await axios.post(
        "http://localhost:5544/api/leaves/add-leave",
        leaveData
      );
      alert(response.data.message);
      setShowDialog(false); // Close dialog after success
      fetchLeaves(); // Refresh the leaves list after adding new leave
    } catch (error) {
      console.error(error);
      alert("Error adding leave. Please try again.");
    }
  };

  return (
    <LeaveLayout>
      <div className="leave-header">
        <h1 className="leave-title">
          <LuCalendarMinus /> Leave
        </h1>
        <Button className="add-leaves-btn" onClick={handleButtonClick}>
          <MdAddCircle className="add-icon" />
        </Button>
      </div>
      <hr />
      <div className="leave-table-container">
        <div className="entries-search-container" style={{ marginTop: 0 }}>
          <Row>
            <Col xs={12} md={6} className="d-flex align-items-center">
              <Dropdown as={ButtonGroup}>
                <Button variant="primary">Show Entries</Button>
                <Dropdown.Toggle
                  split
                  variant="primary"
                  id="dropdown-split-basic"
                />
                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => setEntries(10)}>
                    10
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => setEntries(25)}>
                    25
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => setEntries(50)}>
                    50
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => setEntries(100)}>
                    100
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Col>
            <Col
              xs={12}
              md={6}
              className="d-flex justify-content-end search-container"
            >
              <Form className="d-flex">
                <Form.Control
                  type="search"
                  placeholder="Search"
                  aria-label="Search"
                  className="search-input"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </Form>
            </Col>
          </Row>
        </div>
        <div className="table-responsive">
          <table className="table table-striped leave-table">
            <thead className="table-header">
              <tr className="leave-table-header">
                <th>SR</th>
                <th>Leave Type</th>
                <th>Days</th>
                <th>Description</th>
              </tr>
            </thead>
            <tbody>
              {leaves.length > 0 ? (
                leaves.map((leave, index) => (
                  <tr key={leave._id}>
                    <td>{index + 1}</td>
                    <td>{leave.leaveType}</td>
                    <td>{leave.days}</td>
                    <td>{leave.reason}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4">No leave records found</td>
                </tr>
              )}
            </tbody>
            <tfoot>
              <tr className="leave-table-footer">
                <td>Total</td>
                <td>-</td>
                <td>0</td>
                <td>2</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
      <div className={`slide-dialog ${showDialog ? "slide-dialog-open" : ""}`}>
        <div className="dialog">
          <div className="dialog-header">
            <h2 className="dialog-title">
              <LuCalendarPlus /> Add Leave
            </h2>
            <Button className="submit" onClick={handleAddLeave}>
              <IoMdAdd /> Add Leave
            </Button>
          </div>
          <hr className="dialog-divider" />

          <div className="tab-container">
            <div className="tab-header" onClick={handleTabToggle}>
              <div className="tab-icon">
                <span className="tab-heading">
                  {selectedTab
                    ? `--${selectedTab.replace(/([A-Z])/g, " $1").trim()}--`
                    : "--Leave Type--"}
                </span>
              </div>
              <div
                className={`tab-dropdown ${
                  showTabs ? "tab-dropdown-open" : ""
                }`}
              >
                {[
                  "--Leave Type--",
                  "Holiday",
                  "Sick",
                  "Vacation",
                  "Public Holiday",
                  "Absence Authorized",
                  "Absence Unauthorized",
                  "Compassionate",
                  "Maternity",
                  "Paternity",
                  "Parental",
                  "Carers Leave",
                  "Study Leave",
                  "Training",
                  "Other Leave",
                ].map((tab) => (
                  <div
                    key={tab}
                    className={`tab-item ${
                      selectedTab === tab ? "selected" : ""
                    }`}
                    onClick={() => handleTabSelect(tab)}
                  >
                    {tab}
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div
            className={`date-picker-container ${
              showTabs ? "date-picker-container-open" : ""
            }`}
            ref={datePickerRef}
          >
            <div className="date-picker-group">
              <label htmlFor="start-date">
                Start Date <span className="required">*</span>
              </label>
              <DatePicker
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                className="date-picker"
                placeholderText="Start Date"
              />
            </div>
            <div className="date-picker-group">
              <label htmlFor="end-date">
                End Date <span className="required">*</span>
              </label>
              <DatePicker
                selected={endDate}
                onChange={(date) => setEndDate(date)}
                className="date-picker"
                placeholderText="End Date"
              />
            </div>
          </div>
          <div
            className={`reason-container ${
              showReasonContainer ? "reason-container-open" : ""
            }`}
          >
            <h3 className="reason-title">Reason for Leave</h3>
            <textarea
              className="reason-textarea"
              placeholder="Please provide details for your leave request"
            />
          </div>
        </div>
      </div>
    </LeaveLayout>
  );
}
